import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import {
  Table,
  Input,
  Card,
  Spin,
  Button,
  Modal,
  Form,
  message,
  Typography,
  Space,
} from "antd";

import { useFetch } from "../../../Utils/useFetch";
import { FETCH_ALL_STOCK_API } from "../../../Constants/Apis";
import {updateSku} from "../../../Services/StockService";

const { Search } = Input;
const { Title, Text } = Typography;

const initialState = {
  searchKeyword: "",
};

function reducer(state, action) {
  switch (action.type) {
    case "searchKeyword":
      return { ...state, searchKeyword: action.payload };
    default:
      return state;
  }
}

const SkuValidationPage = ({ history, userData }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [form] = Form.useForm();
const [saving, setSaving] = useState(false);

  const {
    fetchedData: { data = [] },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_STOCK_API}/missing`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  const handleFillSku = (record) => {
    setSelectedRow(record);
    setModalVisible(true);
  };

const handleModalOk = async () => {
  setSaving(true);
  try {
    const values = await form.validateFields();



    await updateSku({
      article: selectedRow.article,
      color: selectedRow.color,
      sku: values.sku,
    });
    message.success("SKU updated successfully");
    callReFetch();
    setModalVisible(false);
    form.resetFields();
  } catch (err) {
    console.error("Error updating SKU:", err);
    message.error("Failed to update SKU");
  }
  setSaving(false);
};

  const handleModalCancel = () => {
    form.resetFields();
    setModalVisible(false);
  };

  const filteredData = data.filter((item) =>
    item.article?.toLowerCase().includes(state.searchKeyword.toLowerCase())
  );

  const columns = [
    {
      title: "Article",
      dataIndex: "article",
      key: "article",
      sorter: (a, b) => a.article.localeCompare(b.article),
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="primary"
          size="small"
          onClick={() => handleFillSku(record)}
        >
          Fill SKU
        </Button>
      ),
    },
  ];

  return (
    <Card
      title={<Title level={4}>SKU Validation</Title>}
      bordered={false}
      style={{ margin: "0 auto", maxWidth: 900 }}
      bodyStyle={{ padding: 20 }}
    >
      <Space direction="vertical" style={{ width: "100%" }}>
        <Search
          placeholder="Search Article"
          onSearch={handleSearch}
          onChange={(e) => handleSearch(e.target.value)}
          allowClear
          style={{ width: 300 }}
        />
        {loading ? (
          <Spin />
        ) : (
          <Table
            columns={columns}
            dataSource={filteredData.map((item, index) => ({
              ...item,
              key: `${item.article}-${item.color}-${index}`,
            }))}
            pagination={{ pageSize: 10 }}
            size="middle"
            bordered
            style={{ backgroundColor: "#fff", borderRadius: 8 }}
          />
        )}
      </Space>

      <Modal
        title={`Fill SKU for "${selectedRow?.article}" - ${selectedRow?.color}`}
        open={modalVisible}
        onOk={handleModalOk}
        confirmLoading={saving}
        onCancel={handleModalCancel}
        okText="Save"
        cancelText="Cancel"
      >
        <p>Do not enter size on the sku since it will be autofill</p>
        <Form form={form} layout="vertical">
          <Form.Item
            label="SKU"
            name="sku"
            rules={[{ required: true, message: "Please input the SKU" }]}
          >
            <Input placeholder="Enter new SKU" />
          </Form.Item>
        </Form>
      </Modal>
    </Card>
  );
};

SkuValidationPage.propTypes = {
  history: PropTypes.object,
  userData: PropTypes.object,
};

export default SkuValidationPage;
